/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(rowProps) {
  var rowSpans = {};
  var data = rowProps.data,
    rowIndex = rowProps.realIndex,
    remoteRowIndex = rowProps.remoteRowIndex,
    columns = rowProps.columns,
    empty = rowProps.empty,
    dataSourceArray = rowProps.dataSourceArray;
  columns === null || columns === void 0 ? void 0 : columns.forEach(function (column) {
    var name = column.name;
    var rowspan = column.rowspan;
    var value = data && name ? data[name] : null;
    var computedRowspan = 1;
    if (typeof rowspan === 'function') {
      computedRowspan = rowspan({
        dataSourceArray: dataSourceArray,
        data: data,
        value: value,
        remoteRowIndex: remoteRowIndex,
        rowIndex: rowIndex,
        column: column,
        columns: columns,
        empty: empty
      });
      rowSpans[column.id] = computedRowspan;
    }
  });
  return rowSpans;
};
exports.default = _default;